// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-blocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18.5 21.5C20.9853 21.5 23 19.4853 23 17C23 14.5147 20.9853 12.5 18.5 12.5C16.0147 12.5 14 14.5147 14 17C14 19.4853 16.0147 21.5 18.5 21.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 20H2V3.5H9L11 6H22V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.9749 14.5251L16.0251 19.4749M21.682 20.182C19.9246 21.9393 17.0754 21.9393 15.318 20.182C13.5607 18.4246 13.5607 15.5754 15.318 13.818C17.0754 12.0607 19.9246 12.0607 21.682 13.818C23.4393 15.5754 23.4393 18.4246 21.682 20.182Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderBlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-blocked',
    ref,
    icon: element,
  },
));

FolderBlockedIcon.displayName = 'FolderBlockedIcon';

export default FolderBlockedIcon;
